import { render, staticRenderFns } from "./layout-footer-button.vue?vue&type=template&id=5272a35e&scoped=true&"
import script from "./layout-footer-button.vue?vue&type=script&lang=js&"
export * from "./layout-footer-button.vue?vue&type=script&lang=js&"
import style0 from "./layout-footer-button.vue?vue&type=style&index=0&id=5272a35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5272a35e",
  null
  
)

export default component.exports